export default [{"url":"https://qwqwrewreqre-0.api.invexerp.io","name":"Branch 1","port":"5024","isStore":true,"isHQ":true}]